import { HttpEventType, HttpResponse } from "@angular/common/http";
import { Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { Observable, Subject } from "rxjs";
import { FileUploadService } from "../../services/file-upload.services";

@Component({
    selector: 'app-file-upload',    
    templateUrl: './upload.component.html',
    styleUrls: ['./upload.component.scss']
  })
export class FileUploadComponent implements OnInit {
    
    @Input() folder: string="";
    @Input() frombook: boolean=false;
    @Input() clipview:boolean = false;
    currentFile?: File;
    progress = 0;
    message = '';  
    fileName = 'Select File';
    fileInfos?: Observable<any>;
  
    constructor(private uploadService: FileUploadService) { }
  
    ngOnInit(): void {
        //this.fileInfos = this.uploadService.getFiles();
    }

    selectFile(event: any): void {

      if (event.target.files && event.target.files[0]) {
        const listFiles = Array.from(event.target.files);
        listFiles.forEach((element: any) => {
          const file: File = element;
          this.currentFile = file;
          this.fileName = this.currentFile.name;
          this.uploadService.onSelectFile(this.folder, this.currentFile, this.frombook);
        });
        
        //this.upload();
      } else {
        this.fileName = 'Select File';
      }
    }  
 }